import { ENDPOINTS } from "./Endpoints"
import { POST } from "./Requests"

export default function saveMep(items, timeline, date) {
    // const mepItems = checkValues(items)
    return POST(ENDPOINTS.updateMEP, { items: items, timeline: timeline , date: date})
}
